import { initTinySlider } from '@stix/helpers';

// Shared web component for slider sections. Replaces the per-section
// Shopify.theme.sections.register('<name>', { _initSliders, onLoad }) modules.
//
// Each slider's options live on its [data-slider] element as a JSON
// data-slider-options attribute, so one component drives any number of
// sliders within a section (e.g. press has two: press + press-logos).
class SliderSection extends HTMLElement {
  connectedCallback() {
    // Sliders init in DOM order by default. When one slider hands its nav to
    // another via navContainer (e.g. press → press-logos), the dependency must
    // init first — set data-slider-order on those to control sequence.
    const sliders = Array.from(this.querySelectorAll('[data-slider]')).sort(
      (a, b) => (Number(a.dataset.sliderOrder) || 0) - (Number(b.dataset.sliderOrder) || 0)
    );
    sliders.forEach(el => {
      const key = el.dataset.slider;
      const options = JSON.parse(el.dataset.sliderOptions || '{}');
      initTinySlider(key, options);
    });
  }
}

if (!customElements.get('slider-section')) {
  customElements.define('slider-section', SliderSection);
}
